<template>
  <div class="editor content-box">
    <el-card shadow="hover">
      <quill-editor class="quill-editor" v-model="form.sysDesc.note" :options="editorOption"></quill-editor>
      <div class="confirm flex">
        <div class="notice">仅支持JPG、PNG两种格式，图片大小不超过2M</div>
        <el-button class="button" type="primary" @click="confirm">确认</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import { Component, Vue } from "vue-property-decorator";
import { saveDesc, getDesc } from "@/api/system";
import quillEditorImgUpload from "@/utils/quillEditorImgUpload";
import Loading from "@/mixins/loading";
export default {
  mixins:[Loading],
  data() {
    return {
      editorOption: "",
      form: {
        id: 2, // 1 关于我们，2权益说明 3售后规则
        sysDesc: {
          id: 0,
          note: "",
          title: "",
          type: 2 // 1 关于我们，2权益说明 3售后规则
        }
      }
    };
  },
  created() {
    this.editorOption = quillEditorImgUpload("equityDescribe");
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.showLoading();
      getDesc({
        id: 2 // 1 关于我们，2权益说明 3售后规则
      }).then(res => {
        this.form = {
          id: res.data.id,
          sysDesc: res.data
        };
      });
       this.hideLoading();
    },
    confirm() {
      saveDesc(this.form).then(res => {
        if (res.code == 200) {
          this.$message.success("提交成功");
        } else {
          this.$message.error("提交失败");
        }
      });
    }
  }
};
</script>


<style lang="scss" scoped src="./style.scss"></style>